import { Inject } from '@angular/core';
import templateSource from './app.component.html';
              import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz');
import { Component, OnInit, ChangeDetectorRef, enableProdMode } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { TranslateService } from '@ngx-translate/core';

interface PwaInstallPromptChoice {
    outcome: 'accepted' | 'dismissed';
    platform: string;
}

interface PwaInstallPromptEvent extends Event {
    readonly platforms?: string[];
    readonly userChoice: Promise<PwaInstallPromptChoice>;
    prompt(): Promise<void>;
}

@Component({
    selector: 'app-root',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/app.component.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.reviewops-pwa-install-alert {
  position: fixed;
  top: max(0.75rem, env(safe-area-inset-top));
  left: 50%;
  z-index: 20000;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(92vw, 540px);
  min-height: 3.25rem;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  color: #ffffff;
  background: rgba(17, 24, 39, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.28);
  transform: translateX(-50%);
}

.reviewops-pwa-install-alert__copy {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.35;
}

.reviewops-pwa-install-alert__copy i {
  flex: 0 0 auto;
  color: #ff8a66;
  font-size: 1rem;
}

.reviewops-pwa-install-alert__copy span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.reviewops-pwa-install-alert__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.375rem;
}

.reviewops-pwa-install-alert__install,
.reviewops-pwa-install-alert__close,
.reviewops-pwa-guide-close,
.reviewops-pwa-guide-confirm {
  border: 0;
  border-radius: 6px;
  font: inherit;
  font-weight: 800;
  cursor: pointer;
}

.reviewops-pwa-install-alert__install {
  min-height: 2rem;
  padding: 0 0.75rem;
  color: #111827;
  background: #ffffff;
}

.reviewops-pwa-install-alert__close,
.reviewops-pwa-guide-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.12);
}

.reviewops-pwa-install-alert__install:hover,
.reviewops-pwa-install-alert__close:hover {
  background: rgba(255, 255, 255, 0.9);
  color: #111827;
}

.reviewops-pwa-install-alert__install:focus-visible,
.reviewops-pwa-install-alert__close:focus-visible,
.reviewops-pwa-guide-close:focus-visible,
.reviewops-pwa-guide-confirm:focus-visible {
  outline: 2px solid #ff8a66;
  outline-offset: 2px;
}

.reviewops-pwa-guide-backdrop {
  position: fixed;
  inset: 0;
  z-index: 20010;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.48);
}

.reviewops-pwa-guide-dialog {
  box-sizing: border-box;
  width: min(92vw, 420px);
  max-height: calc(var(--reviewops-viewport-height, 100vh) - 2rem);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1rem;
  color: #111827;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
}

.reviewops-pwa-guide-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.reviewops-pwa-guide-header h2 {
  margin: 0;
  font-size: 1rem;
  font-weight: 900;
  line-height: 1.35;
}

.reviewops-pwa-guide-close {
  flex: 0 0 auto;
  color: #111827;
  background: #f3f4f6;
}

.reviewops-pwa-guide-close:hover {
  background: #e5e7eb;
}

.reviewops-pwa-guide-note {
  margin: 0.75rem 0 0;
  color: #4b5563;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.5;
}

.reviewops-pwa-guide-steps {
  margin: 0.875rem 0 0;
  padding-left: 1.25rem;
  color: #111827;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.55;
}

.reviewops-pwa-guide-steps li + li {
  margin-top: 0.5rem;
}

.reviewops-pwa-guide-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.reviewops-pwa-guide-confirm {
  min-height: 2.25rem;
  padding: 0 0.875rem;
  color: #ffffff;
  background: #111827;
}

.reviewops-pwa-guide-confirm:hover {
  background: #1f2937;
}

@media (max-width: 480px) {
  .reviewops-pwa-install-alert {
    align-items: flex-start;
    width: calc(100vw - 1rem);
    padding: 0.625rem;
  }
  .reviewops-pwa-install-alert__copy {
    align-items: flex-start;
    font-size: 0.8125rem;
  }
  .reviewops-pwa-guide-backdrop {
    align-items: flex-end;
    padding: 0.75rem;
  }
  .reviewops-pwa-guide-dialog {
    width: 100%;
  }
}`],
})
export class AppComponent implements OnInit {
    public pwaBannerVisible = false;
    public pwaGuideVisible = false;
    public pwaInstallAvailable = false;
    public pwaInstallMessage = '브라우저 메뉴에서 ReviewOps를 홈 화면에 추가하세요.';
    public pwaGuideTitle = '홈 화면에 추가하는 방법';
    public pwaGuideNote = '이 브라우저는 자동 설치 창을 제공하지 않아 수동 추가가 필요합니다.';
    public pwaGuideSteps: string[] = [];

    private pwaInstallPrompt: PwaInstallPromptEvent | null = null;
    private readonly pwaDismissKey = 'reviewops:pwa-install-banner-dismissed';
    private readonly pwaInstalledKey = 'reviewops:pwa-installed';

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         public router: Router,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( TranslateService    )         public translate: TranslateService    ) {
        window['MonacoEnvironment'] = {
            getWorkerUrl: function (moduleId: string, label: string) {
                return `/lib/vs/base/worker/workerMain.js`;
            }
        };
        this.bindPwaInstallEvents();
    }

    public async ngOnInit() {
        enableProdMode();
        this.registerServiceWorker();
        this.applyDefaultDocumentTitle();
        this.evaluatePwaInstallBanner();
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) this.applyDefaultDocumentTitle();
        });
        await this.service.init(this);
    }

    public applyDefaultDocumentTitle() {
        const path = window.location.pathname || '';
        const match = path.match(/^\/projects\/([^/?#]+)/);
        const detailProject = match && ['mine', 'participating'].indexOf(match[1]) < 0;
        if (!detailProject) document.title = 'SEASON::ReviewOps';
    }

    public async installPwa(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.pwaInstallPrompt) {
            this.openPwaInstallGuide();
            return;
        }
        const promptEvent = this.pwaInstallPrompt;
        this.pwaInstallPrompt = null;
        this.pwaInstallAvailable = false;

        try {
            await promptEvent.prompt();
            const choice = await promptEvent.userChoice;
            if (choice.outcome === 'accepted') this.markPwaInstalled();
        } catch (error) {
            console.warn('PWA install prompt failed.', error);
            this.openPwaInstallGuide();
            return;
        }

        this.dismissPwaBanner();
    }

    public dismissPwaBanner(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.pwaBannerVisible = false;
        try {
            window.sessionStorage.setItem(this.pwaDismissKey, '1');
        } catch (error) {
            // Ignore storage restrictions in private browsing or embedded contexts.
        }
        this.ref.detectChanges();
    }

    public openPwaInstallGuide(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.pwaGuideSteps = this.getPwaInstallGuideSteps();
        this.pwaGuideVisible = true;
        this.ref.detectChanges();
    }

    public closePwaInstallGuide(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.pwaGuideVisible = false;
        this.ref.detectChanges();
    }

    private bindPwaInstallEvents() {
        window.addEventListener('beforeinstallprompt', (event: Event) => {
            event.preventDefault();
            this.pwaInstallPrompt = event as PwaInstallPromptEvent;
            this.pwaInstallAvailable = true;
            this.evaluatePwaInstallBanner();
            this.ref.detectChanges();
        });

        window.addEventListener('appinstalled', () => {
            this.markPwaInstalled();
            this.pwaInstallPrompt = null;
            this.pwaInstallAvailable = false;
            this.pwaBannerVisible = false;
            this.pwaGuideVisible = false;
            this.ref.detectChanges();
        });
    }

    private registerServiceWorker() {
        if (!('serviceWorker' in navigator)) return;
        if (!this.isSecureContextForServiceWorker()) return;

        const register = () => {
            navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
                console.warn('Service worker registration failed.', error);
            });
        };

        if (document.readyState === 'complete') register();
        else window.addEventListener('load', register, { once: true });
    }

    private evaluatePwaInstallBanner() {
        const pwaDisplayMode = this.isPwaDisplayMode();
        if (pwaDisplayMode) this.markPwaInstalled();

        this.pwaInstallMessage = this.pwaInstallAvailable
            ? 'ReviewOps를 홈 화면에 설치할 수 있습니다.'
            : '브라우저 메뉴에서 ReviewOps를 홈 화면에 추가하세요.';
        this.pwaBannerVisible = this.isMobileDevice()
            && !pwaDisplayMode
            && !this.isPwaInstalledKnown()
            && !this.isPwaBannerDismissed();
    }

    private getPwaInstallGuideSteps() {
        const userAgent = window.navigator.userAgent || '';
        const isIos = /iPhone|iPad|iPod/i.test(userAgent);
        const isAndroid = /Android/i.test(userAgent);

        if (isIos) {
            return [
                'Safari 하단 또는 상단의 공유 버튼을 누릅니다.',
                '공유 메뉴에서 홈 화면에 추가를 선택합니다.',
                '오른쪽 상단의 추가를 누르면 홈 화면에 ReviewOps가 추가됩니다.'
            ];
        }

        if (isAndroid) {
            return [
                'Chrome 오른쪽 위 더보기 메뉴를 누릅니다.',
                '앱 설치 또는 홈 화면에 추가를 선택합니다.',
                '확인 창에서 설치 또는 추가를 누릅니다.'
            ];
        }

        return [
            '브라우저 메뉴를 엽니다.',
            '앱 설치, 바로가기 만들기, 또는 홈 화면에 추가 메뉴를 선택합니다.',
            '확인 창에서 설치 또는 추가를 누릅니다.'
        ];
    }

    private isPwaDisplayMode() {
        const standaloneMedia = window.matchMedia('(display-mode: standalone)').matches;
        const navigatorStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
        return standaloneMedia || navigatorStandalone;
    }

    private isMobileDevice() {
        const userAgent = window.navigator.userAgent || '';
        const mobileUserAgent = /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
        const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
        const narrowViewport = window.matchMedia('(max-width: 768px)').matches;
        return mobileUserAgent || (coarsePointer && narrowViewport);
    }

    private isPwaBannerDismissed() {
        try {
            return window.sessionStorage.getItem(this.pwaDismissKey) === '1';
        } catch (error) {
            return false;
        }
    }

    private isPwaInstalledKnown() {
        try {
            return window.localStorage.getItem(this.pwaInstalledKey) === '1';
        } catch (error) {
            return false;
        }
    }

    private markPwaInstalled() {
        try {
            window.localStorage.setItem(this.pwaInstalledKey, '1');
        } catch (error) {
            // Ignore storage restrictions in private browsing or embedded contexts.
        }
    }

    private isSecureContextForServiceWorker() {
        return window.location.protocol === 'https:'
            || window.location.hostname === 'localhost'
            || window.location.hostname === '127.0.0.1';
    }
}
